import type { ValueOf } from '@weft/utils';

export const REPORT_TYPES = Object.freeze({
  ALL_REPORTS: 'All reports',
  CONTRACTS: 'Contracts Report',
  COMMITMENT_USAGE: 'Commitment Usage',
  UNCHARGED_USAGE: 'Uncharged Usage',
  ANONYMOUS_CUSTOMERS: 'Anonymous Customers',
  PRODUCTS_USAGE: 'Products',
  CUSTOMER_REVENUE: 'Revenue Analysis',
  AR_AGING: 'AR Aging',
  MONTHLY_CLOUSER: 'Monthly Closure',
});

export type ReportType = ValueOf<typeof REPORT_TYPES>;